export enum TableStatus {
	open = "open",
	order_printed = "order_printed",
	bill_printed = "bill_printed",
	order_saved = "order_saved",
	order_waiting = "order_waiting",
	order_split = "order_split",

	Free = "Free",
	Dirty = "Dirty",
	Occupied = "Occupied",
	Booked = "Booked",
	Locked = "Locked",
	CleanedUp = "CleanedUp",
	ReleaseOccupation = "ReleaseOccupation",
	ReleaseBooking = "ReleaseBooking",
	ReleaseLocking = "ReleaseLocking",
	Maintenance = "Maintenance",
	ReleaseMaintenance = "ReleaseMaintenance",
	Split = "Split",
	BillPrinted = "BillPrinted",
	BillPartialPrinted = "BillPartialPrinted",
}

export enum TicketStatus {
	Free = "Free",
	Open = "Open",
	Voided = "Voided",
	Paid = "Paid",
	Closed = "Closed",
	Saved = "Saved",
	Reopened = "Reopened",
	Refunded = "Refunded",
	BillPrinted = "BillPrinted",
	Waiting = "Waiting",
	BillPartialPrinted = "BillPartialPrinted",
	PaidAndClosed = "PaidAndClosed",
	PaidAndReopen = "PaidAndReopen",
	Release = "Release",
	Pending = "Pending",
}

// export enum GroupKitchen {
// 	Free = "Free",
// 	Open = "Open",
// 	Voided = "Voided",
// 	Paid = "Paid",
// 	Closed = "Closed",
// 	Saved = "Saved",
// 	Reopened = "Reopened",
// 	Refunded = "Refunded",
// 	BillPrinted = "BillPrinted",
// 	Waiting = "Waiting",
// 	BillPartialPrinted = "BillPartialPrinted",
// 	PaidAndClosed = "PaidAndClosed",
// 	PaidAndReopen = "PaidAndReopen",
// 	Release = "Release",
// 	Pending = "Pending",
// }


export enum ItemType {
	menu_item = "menu_item",
	item_modifier = "item_modifier",
	item_special = "item_special",
	item_discount = "item_discount",
}

export enum TicketType {
	ALL = "All",
	NORMAL = "NORMAL",
	DINE_IN = "DINE_IN",
	TAKE_OUT = "TAKE_OUT",
	DELIVERY = "DELIVERY",
	VIP = "VIP",
	SPLIT = "split",
}

export enum PaymentStatus {
	None = "None",
	Paid = "Paid",
	Closed = "Closed",
}

export enum ViewMode {
	Add,
	Edit,
	Copy,
	Delete,
}

export enum InView {
	Table_Grid,
	Ticket_List,
	Items,
	Order,
	Kitchen
}

export interface DataPopupSetting {
	id: number | string;
	title?: string;
	message: string;
	isHideCancel?: boolean;
	isHideIcon?: boolean;
	color?: string;
	status?: string;
}

export enum LocalStorageKey {
	user_info = "user_info",
	refresh_token = "refresh_token",
	access_token = "access_token",
	id_token = "id_token",
	tokenType = "tokenType",
	expires_at = "expires_at",
	id_token_claims_obj = "id_token_claims_obj",
	id_token_stored_at = "id_token_stored_at",
	access_token_stored_at = "access_token_stored_at",
	X_PERM = "X-PERM",
	X_AUTO_LOGOFF = "X-AUTO-LOGOFF",
	X_DEFAULT_LANGUAGE = "X-DEFAULT-LANGUAGE",
	X_DEVICE_TYPE = "X-DEVICE-TYPE",
	language = "language",
	table_detail = "table_detail",
	iTransfer = "iTransfer",
	tbls = "tbls",
	logOff = "logOff",
	POS_VIEW = "POS_VIEW",
	TIME_APP_MINIMIZE = "time_app_minimize",
}

export enum PrintType {
	Print = "Print",
	PrintAndWait = "PrintAndWait",
	PrintAndVoid = "PrintAndVoid",
	PrintReview = "PrintReview",
	PrintVoidTicket = "PrintVoidTicket",
	PrintVoidTicketItem = "PrintVoidTicketItem",
	PrintBillAfterPaid = "PrintBillAfterPaid",
	PrintBillCustomer = "PrintBillCustomer",
	PrintBillCustomerByAutoId = "PrintBillCustomerByAutoId",
}
